import {
  Component,
  OnInit,
  OnDestroy,
  ViewChild,
  Inject,
  NgZone,
} from "@angular/core";
import { Subscription } from "rxjs";
import { Router, ActivatedRoute } from "@angular/router";
import { MatSidenav, MatSnackBar } from "@angular/material";
import { HttpClient } from "@angular/common/http";
import { HttpErrorResponse } from "@angular/common/http";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { LayerService } from "../layer/layer.service";
import { PoiService } from "../poi/poi.service";
import { UserService } from "../users/user.service";
import { CitiesService } from "../cities/cities.service";
import { LocationsService } from "../user/locations.service";
import { LoggerService } from "../logger.service";
import Amplify, { Storage } from "aws-amplify";
import { AmplifyService } from "aws-amplify-angular";
import aws_exports from "../../aws-exports";
import { v4 as uuid } from "uuid";
import { randomColor } from "randomcolor";

Amplify.configure(aws_exports);

import { GeolocationService } from "../user/geolocation.service";
import { TranslateService } from "../translate.service";

export interface PoiLayer {
  id: string;
  name: string;
  color: string;
  kmlkmz: string;
}

@Component({
  selector: "app-relieve",
  templateUrl: "./relieve.component.html",
  styleUrls: ["./relieve.component.css"],
})
export class RelieveComponent implements OnInit, OnDestroy {
  @ViewChild("poiFormPanel") poiFormPanel: MatSidenav;
  @ViewChild("poiRightPanel") poiRightPanel: MatSidenav;
  private currentRightPanel = null;

  private filter_object;
  private filter_column;
  private filter_operator;
  private filter_value;
  private filter_group;
  private filtersGroups;
  private defaultPoiLayer = null;
  private searchpoi = false;
  private user;
  private cities = [];
  private currentCity = null;
  private pois = [];
  private numberingHistory = [1];
  private interdistanceHistory = [];
  private lastTwoPois = [];
  private poiOriginalData = null;
  private lastPoiSequentially;
  private poilayers = [];
  private poitypes = [];
  private poitypestructure = [];
  private selectedPoiLayers = [];
  private poiData = null;
  private poiDataUpdates = null;
  private poiFiles = [];
  private poiID = "";
  private poiForm = {};
  private poiFormPanelStatus = false;
  private currentPoiType = "";
  private lastInsertedPoi = null;
  private currentPoiLayer = null;
  private map;
  private bounds = null;
  private poiQrcode = null;
  private borderPolygon;
  private poiIconSize = 25;
  private layerLocked = true;
  private poitypeLocked = true;
  private poiAction = null;
  private poiInfowindowdata = null;
  private userGeolocationObj = null;
  private userPreferencies = [];
  private userPositions = [];
  private colleagues = [];
  private colleaguesKeys = Object.keys;
  private colleaguesIcons = [];
  private showColleagues = false;
  private colors = [];
  private customicons = [];
  private searchpoi_data = null;
  private currentMarker = {
    index: null,
    position: {
      latitude: 0,
      longitude: 0,
    },
    marker: null,
    layer: null,
  };
  private currentMarkers = [];
  private subscriptions: Subscription[] = [];
  private poiServiceSubscription: any = null;
  private mapCenter = {
    latitude: 0,
    longitude: 0,
    zoom: 3,
  };
  private mapOptions = {
    disableBirdseye: true,
    disableStreetside: false,
    navigationBarMode: 1,
    zoom: 3,
    showCopyright: false,
  };

  private currentUserPosition = null;

  private currentUserPositionIcon =
    "data:image/svg+xml;utf-8," +
    encodeURIComponent(`
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <circle cx="16" cy="16" r="10" fill="#2196f3" opacity="0.25"/>
      <circle cx="16" cy="16" r="6" fill="#2196f3" stroke="white" stroke-width="3"/>
    </svg>
  `);

  addRandomColors() {
    let self = this;
    for (var i = 0; i < 10; i++) {
      self.colors.push(randomColor({ format: "rgb" }));
    }
  }

  loadPoisOnMap() {
    let self = this;
    if (self.poilayers) {
      for (let layer of self.poilayers) {
        layer.poi = {};
        layer.poi.items = [];
        self.loadAllFromLayerBounded(
          layer,
          self.user.organization,
          self.bounds.maxLatitude,
          self.bounds.maxLongitude,
          self.bounds.minLatitude,
          self.bounds.minLongitude,
        );
      }
    }
  }

  updateMapBounds(e) {
    this.bounds = {};
    this.bounds.maxLatitude = e.getNorthEast().lat();
    this.bounds.maxLongitude = e.getNorthEast().lng();
    this.bounds.minLatitude = e.getSouthWest().lat();
    this.bounds.minLongitude = e.getSouthWest().lng();
  }

  clearPoisOnMap() {
    let self = this;
    if (self.poilayers) {
      for (let layer of self.poilayers) {
        layer.poi = {};
        layer.poi.items = [];
      }
    }
  }

  poiFormPanelEvent(e) {
    this.poiFormPanelStatus = e;
  }

  private mapReady(map) {
    let self = this;
    if (map) {
      map.controls[google.maps.ControlPosition.TOP_LEFT].push(
        document.getElementById("poi-map-toptoolbar-left"),
      );
      map.controls[google.maps.ControlPosition.TOP_RIGHT].push(
        document.getElementById("poi-map-toptoolbar-right"),
      );
      map.controls[google.maps.ControlPosition.BOTTOM_LEFT].push(
        document.getElementById("poi-map-lefbottomtoolbar"),
      );
      map.setOptions({
        zoomControlOptions: {
          position: google.maps.ControlPosition.RIGHT_CENTER,
        },
        mapTypeControlOptions: {
          style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
          position: google.maps.ControlPosition.BOTTOM_LEFT,
        },
        streetViewControl: true,
        streetViewControlOptions: {
          position: google.maps.ControlPosition.RIGHT_CENTER,
        },
        fullscreenControl: false,
      });
      self.map = map;
      self.map.setOptions({ tilt: 0 });
    }
  }

  private poiDragEnd(data, poi, li, index) {
    let self = this;
    if (data && data.coords) {
      const newLatitude = data.coords.lat;
      const newLongitude = data.coords.lng;

      // Update temporaly markers position
      self.currentMarker.position.latitude = newLatitude;
      self.currentMarker.position.longitude = newLongitude;

      // Update POI position if it exists
      if (poi) {
        poi.position_lat = newLatitude;
        poi.position_lng = newLongitude;
      }

      self.currentMarkers.forEach((marker) => {
        if (marker.poiID === poi.id || (!marker.poiID && !poi.id)) {
          marker.position.latitude = newLatitude;
          marker.position.longitude = newLongitude;
        }
      });

      self.lastTwoPois[0] = {
        lat: newLatitude,
        lng: newLongitude,
      };

      if (self.interdistanceHistory && self.interdistanceHistory.length > 1) {
        self.interdistanceHistory[0].lat = data.coords.lat;
        self.interdistanceHistory[0].lng = data.coords.lng;
        var interdistance = self.distance(
          self.interdistanceHistory[1].lat,
          self.interdistanceHistory[1].lng,
          self.interdistanceHistory[0].lat,
          self.interdistanceHistory[0].lng,
        );
        self.poiDataUpdates = {
          ...(self.poiDataUpdates || {}),
          post_interdistance: interdistance,
        };
      }
    }
  }

  private toggleRightPanel(panel) {
    let self = this;
    self.currentRightPanel = panel;
    self.poiRightPanel.toggle();
  }

  private editLayers() {
    let self = this;
    self.toggleRightPanel("layers");
  }

  private resetCurrentMarker() {
    let self = this;
    self.poiFormPanel.close();
    self.poiFiles = [];
    self.poiID = null;
    self.poiDataUpdates = null;
    self.poiData = null;
    if (
      self.isNumeric(self.currentMarker.layer) &&
      self.isNumeric(self.currentMarker.index)
    ) {
      if (
        self.currentMarker &&
        self.isNumeric(self.currentMarker.layer) &&
        self.isNumeric(self.currentMarker.index) &&
        self.poilayers[self.currentMarker.layer] &&
        self.poilayers[self.currentMarker.layer].poi &&
        self.poilayers[self.currentMarker.layer].poi.items &&
        self.poilayers[self.currentMarker.layer].poi.items[
          self.currentMarker.index
        ] &&
        self.poilayers[self.currentMarker.layer].poi.items[
          self.currentMarker.index
        ].current
      )
        self.poilayers[self.currentMarker.layer].poi.items[
          self.currentMarker.index
        ].current = false;
      if (self.currentMarkers && self.currentMarkers.length > 0) {
        self.currentMarkers.forEach((currentMarker) => {
          if (
            currentMarker &&
            self.isNumeric(currentMarker.layer) &&
            self.isNumeric(currentMarker.index) &&
            self.poilayers[currentMarker.layer] &&
            self.poilayers[currentMarker.layer].poi &&
            self.poilayers[currentMarker.layer].poi.items &&
            self.poilayers[currentMarker.layer].poi.items[
              currentMarker.index
            ] &&
            self.poilayers[currentMarker.layer].poi.items[currentMarker.index]
              .current
          )
            self.poilayers[currentMarker.layer].poi.items[
              currentMarker.index
            ].current = false;
        });
      }
    }
    self.currentMarker.index = null;
    self.currentMarker.layer = null;
    self.currentMarker.marker = null;
    self.currentMarker.position.latitude = 0;
    self.currentMarker.position.longitude = 0;
    self.currentMarkers = [];
  }

  private poiIcon(poi) {
    let self = this,
      icon = "";

    self.poitypes.forEach((poitype) => {
      if (
        poitype &&
        poitype.hasOwnProperty("name") &&
        poi.hasOwnProperty("type") &&
        poi.type != null &&
        poi.type.hasOwnProperty("name") &&
        poitype.name == poi.type.name
      ) {
        icon = poitype.icon || "";
      }
    });

    if (poi.current) {
      return "assets/img/markers/current.png";
    } else {
      if (poi.searchedFor) {
        return "assets/img/markers/current.png";
      }

      if (self.filtersGroups && self.filtersGroups.length > 0) {
        for (var filtergroup of self.filtersGroups) {
          if (filtergroup.active && poi.data) {
            if (typeof poi.data == "string" || poi.data instanceof String)
              poi.data = JSON.parse(poi.data);
            if (!filtergroup.filters || filtergroup.filters.length === 0)
              continue;
            var valid = true;
            var color = filtergroup.color ? filtergroup.color : "blue";
            for (var filter of filtergroup.filters) {
              if (
                filter.poitype &&
                filter.poitype.name &&
                poi.type &&
                poi.type.name
              ) {
                if (filter.poitype.name !== poi.type.name) {
                  valid = false;
                  break;
                }
              }
              if (
                filter.column &&
                filter.column.prop in poi.data &&
                poi.data[filter.column.prop] !== null &&
                poi.data[filter.column.prop] !== undefined
              ) {
                const propVal = poi.data[filter.column.prop].toString();
                const filterVal = filter.value.toString();
                switch (filter.operator) {
                  case 0:
                    if (propVal != filterVal) valid = false;
                    break;
                  case 1:
                    if (!(parseFloat(propVal) > parseFloat(filterVal)))
                      valid = false;
                    break;
                  case 2:
                    if (!(parseFloat(propVal) < parseFloat(filterVal)))
                      valid = false;
                    break;
                  case 4:
                    if (propVal == filterVal) valid = false;
                    break;
                  case 5:
                    if (!propVal.includes(filterVal)) valid = false;
                    break;
                  case 6:
                    if (!propVal.startsWith(filterVal)) valid = false;
                    break;
                  case 7:
                    if (!propVal.endsWith(filterVal)) valid = false;
                    break;
                  case 8:
                    if (propVal.includes(filterVal)) valid = false;
                    break;
                }
              } else {
                valid = false;
              }
              if (!valid) break;
            }
            if (valid) {
              if (filtergroup.hide) {
                return (
                  'data:image/svg+xml;utf-8, <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0" y="0" width="' +
                  self.poiIconSize +
                  '" height="' +
                  self.poiIconSize +
                  '" viewBox="0, 0, ' +
                  self.poiIconSize +
                  ", " +
                  self.poiIconSize +
                  '"></svg>'
                );
              } else {
                if (filtergroup.customicon) {
                  return filtergroup.customicon.URI;
                } else
                  return (icon || "")
                    .replace(/\\"/g, '"')
                    .replace(/##SIZE##/g, self.poiIconSize.toString())
                    .replace(
                      /##SIZE2##/g,
                      (self.poiIconSize / 2).toFixed(1).toString(),
                    )
                    .replace(
                      /##SIZERADIUS##/g,
                      (self.poiIconSize / 2 - 3).toFixed(1).toString(),
                    )
                    .replace(/##COLOR##/g, color.toString())
                    .slice(1, -1);
              }
            }
          }
        }
      }
    }

    let finalColor = "red";
    let parsedData: any = null;
    if (poi && poi.data) {
      try {
        parsedData =
          typeof poi.data === "string" ? JSON.parse(poi.data) : poi.data;
      } catch (e) {
        parsedData = null;
      }
    }
    if (parsedData) {
      const poiTypeName =
        poi && poi.type && poi.type.name ? poi.type.name.toString() : "";
      const hasPostOwner =
        parsedData.post_owner !== undefined &&
        parsedData.post_owner !== null &&
        parsedData.post_owner !== "";
      const hasCabinetOwner =
        parsedData.cabinet_owner !== undefined &&
        parsedData.cabinet_owner !== null &&
        parsedData.cabinet_owner !== "";

      //Punto luce
      if (hasPostOwner && poiTypeName !== "cabinet") {
        switch (parsedData.post_owner.toString()) {
          case "0":
            finalColor = "rgb(58,83,155)";
            break; // Municipale - blu
          case "1":
            finalColor = "rgb(235, 59, 91)";
            break; // Enel Sole - rosso bordeaux
          case "2":
            finalColor = "rgb(0,200,83)";
            break; // Progetto - verde
          case "3":
            finalColor = "rgb(254, 1, 0)";
            break; // Enel Distribuzione - rosso
          case "999":
            finalColor = "rgb(254, 211, 46)";
            break; // Altro - arancio
        }
      }

      //Quadro
      if (hasCabinetOwner && (poiTypeName === "cabinet" || !hasPostOwner)) {
        switch (parsedData.cabinet_owner.toString()) {
          case "0":
            finalColor = "rgb(58,83,155)";
            break; // Municipale - blu
          case "1":
            finalColor = "rgb(0,200,83)";
            break; // Enel Sole - verde
          case "2":
            finalColor = "rgb(128,0,128)";
            break; // Progetto - viola
          case "999":
            finalColor = "rgb(128,128,128)";
            break; // Altro - grigio
        }
      }
    }

    return icon
      .replace(/\\"/g, '"')
      .replace(/##SIZE##/g, self.poiIconSize.toString())
      .replace(/##SIZE2##/g, (self.poiIconSize / 2).toFixed(1).toString())
      .replace(
        /##SIZERADIUS##/g,
        (self.poiIconSize / 2 - 3).toFixed(1).toString(),
      )
      .replace(/##COLOR##/g, finalColor)
      .slice(1, -1);
  }

  private isNumeric(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
  }

  private showPoiInfoBubble(poi) {
    let self = this,
      stringdata = "";
    if (
      poi &&
      poi.hasOwnProperty("type") &&
      poi.type != null &&
      poi.type.hasOwnProperty("name")
    ) {
      self.poitypes.forEach((poitype) => {
        if (
          poitype &&
          poitype.hasOwnProperty("name") &&
          poi.hasOwnProperty("type") &&
          poi.type.hasOwnProperty("name") &&
          poitype.name == poi.type.name
        ) {
          let infowindow = JSON.parse(poitype.infowindow);
          if (infowindow && infowindow.hasOwnProperty("elements")) {
            let infowindowdatas = infowindow.elements;
            infowindowdatas.forEach((infowindowdata) => {
              if (
                infowindowdata &&
                infowindowdata.hasOwnProperty("type") &&
                infowindowdata.hasOwnProperty("value")
              ) {
                switch (infowindowdata.type) {
                  case "text":
                    stringdata += "<p>" + infowindowdata.value + "</p>";
                    break;
                  case "element":
                    if (
                      poi &&
                      poi.hasOwnProperty("data") &&
                      poi.data.hasOwnProperty(infowindowdata.value)
                    )
                      stringdata +=
                        "<p>" +
                        (self.translateService.data[infowindowdata.value] ||
                          infowindowdata.value) +
                        ": " +
                        poi.data[infowindowdata.value] +
                        "</p>";
                    break;
                }
              }
            });
          }
        }
      });
      return stringdata;
    }
  }

  private poiCheckDuplication(
    postNumber: string,
    excludePoiIds: string[] = [],
    lightingBody: any = null,
  ) {
    let self = this;
    let duplicateFound = false;
    const excludedPoiIds = {};
    const useLightingBody =
      lightingBody !== null &&
      lightingBody !== undefined &&
      lightingBody !== "";

    if (excludePoiIds && excludePoiIds.length > 0) {
      excludePoiIds.forEach((id) => {
        if (id) excludedPoiIds[id] = true;
      });
    }

    if (self.poilayers && self.poilayers.length > 0 && postNumber) {
      self.poilayers.forEach((poilayer) => {
        if (!poilayer.poi || !poilayer.poi.items) return;
        poilayer.poi.items.forEach((poi) => {
          if (poi && poi.data) {
            if (typeof poi.data == "string" || poi.data instanceof String) {
              try {
                poi.data = JSON.parse(poi.data);
              } catch (e) {
                return;
              }
            }

            // Check if the poi is duplicate by post number
            let isDuplicate =
              poi.data &&
              poi.data.post_number &&
              poi.data.post_number.toString().toLowerCase() ===
                postNumber.toLowerCase();

            // Check if the poi is duplicate by lighting body
            if (useLightingBody) {
              const currentLightingBody = poi.data.hasOwnProperty(
                "lighting_body",
              )
                ? String(poi.data.lighting_body)
                : "";

              //FLOW:
              // If lighting body is single (lighting_body = 0), then the poi is duplicate by post number
              // If lighting body is not single (lighting_body = 1, 2, 3, 4, 5, 6, 7), then the poi is duplicate if the post number and lighting body are the same
              if (String(lightingBody) === "0") {
                // niente filtro aggiuntivo: stesso palo => duplicato
                isDuplicate = isDuplicate;
              } else {
                isDuplicate =
                  isDuplicate &&
                  (currentLightingBody === String(lightingBody) ||
                    currentLightingBody === "0");
              }
            }

            const isExcluded = poi.id && excludedPoiIds[poi.id];

            if (isDuplicate && !isExcluded) {
              duplicateFound = true;
              poi.searchedFor = true;
            } else {
              poi.searchedFor = false;
            }
          }
        });
      });
    }

    if (duplicateFound) {
      self.snackbar.open("Attenzione, il numero di POI già in uso!", "ok", {
        duration: 5000,
        panelClass: ["white-snackbar"],
      });
      self.dialog.open(DialogPOIExists, {
        width: "250px",
      });
    }

    return duplicateFound;
  }

  private getDuplicateKey(postNumber: any, lightingBody: any): string {
    const normalizedPostNumber =
      postNumber !== null && postNumber !== undefined
        ? postNumber.toString().trim().toLowerCase()
        : "";
    const normalizedLightingBody =
      lightingBody !== null && lightingBody !== undefined
        ? lightingBody.toString().trim().toLowerCase()
        : "";
    return `${normalizedPostNumber}__${normalizedLightingBody}`;
  }

  private poiEditPropChanged(e) {
    let self = this;
    if (e && e.hasOwnProperty("prop") && e.prop.hasOwnProperty("key")) {
      switch (e.prop.key) {
        case "post_number":
        case "lighting_body":
          if (
            e.hasOwnProperty("value") &&
            e.value !== null &&
            e.value !== undefined &&
            e.value !== ""
          ) {
            const poiData =
              self.poiData && !Array.isArray(self.poiData)
                ? self.poiData
                : (self.poiData && self.poiData[0]) || {};
            const excludePoiIds = (self.currentMarkers || [])
              .map((currentMarker) =>
                currentMarker && currentMarker.poiID
                  ? currentMarker.poiID
                  : null,
              )
              .filter((poiId) => !!poiId);
            const postNumber =
              e.prop.key === "post_number" ? e.value : poiData.post_number;
            const lightingBody =
              e.prop.key === "lighting_body" ? e.value : poiData.lighting_body;

            if (postNumber) {
              self.poiCheckDuplication(
                postNumber.toString(),
                excludePoiIds,
                lightingBody,
              );
            }
          }
          break;
      }
    }
  }

  private searchPoiChanged(searchpoi_data) {
    let self = this;
    self.poilayers.forEach((poilayer) => {
      poilayer.poi.items.forEach((poi) => {
        if (poi && poi.data) {
          if (typeof poi.data == "string" || poi.data instanceof String)
            poi.data = JSON.parse(poi.data);
          if (
            poi.data &&
            poi.data.post_number &&
            poi.data.post_number
              .toString()
              .toLowerCase()
              .startsWith(searchpoi_data.toLowerCase())
          ) {
            poi.searchedFor = true;
            self.mapCenter.latitude = poi.position_lat;
            self.mapCenter.longitude = poi.position_lng;
            self.mapCenter.zoom = 14;
          } else {
            poi.searchedFor = false;
          }
        }
      });
    });
  }

  private resetPoiSearch() {
    this.searchpoi_data = null;

    this.poilayers.forEach((poilayer) => {
      poilayer.poi.items.forEach((poi) => {
        poi.searchedFor = false;
      });
    });
  }
  // Args*: required
  // marker: the marker object
  // poi: the poi object
  // layer: the layer object
  // index: the index of the poi
  // multipleSelection: a boolean indicating if the poi is part of a multiple selection
  private poiEdit(marker, poi, layer, index, multipleSelection = false) {
    let self = this;

    if (self.currentMarkers) {
      console.log(self.currentMarkers);
    }

    if (!multipleSelection) {
      self.resetCurrentMarker();
      self.currentMarkers = [];
      self.poiData = null;
      self.poiFiles = [];
      self.poiID = null;
      self.poiDataUpdates = null;
    }

    self.poiAction = "editing";
    if (
      marker &&
      poi &&
      poi.id &&
      self.isNumeric(index) &&
      self.isNumeric(layer)
    ) {
      const selectedMarkerIndex = self.currentMarkers.findIndex(
        (currentMarker) => currentMarker.poiID === poi.id,
      );

      if (selectedMarkerIndex >= 0) {
        self.currentMarkers.splice(selectedMarkerIndex, 1);
        self.poilayers[layer].poi.items[index].current = false;
        if (self.currentMarkers.length > 0) {
          setTimeout(() => {
            self.poiData = self.currentMarkers.map((currentMarker) =>
              JSON.parse(JSON.stringify(currentMarker.data)),
            );
          }, 0);
        } else {
          self.resetCurrentMarker();
        }
        return;
      }

      self.poilayers[layer].poi.items[index].current = true;
      self.currentMarker.index = index;
      self.currentMarker.layer = layer;
      self.currentMarker.marker = marker;
      self.poiOriginalData = {
        position: {
          latitude: marker.latitude,
          longitude: marker.longitude,
        },
      };
      self.poiService
        .get(poi.id)
        .then((data) => {
          // Fallback to prevent race condition
          // if Annulla was pressed before this resolved, currentMarker was reset
          if (
            self.currentMarker.index !== index ||
            self.currentMarker.layer !== layer
          ) {
            return;
          }
          try {
            if (data && data.data && data.data.getPoi) {
              var poiData = data.data.getPoi;
              self.poiQrcode =
                "https://app2.egaia.net/Dashboard/" +
                self.currentCity.id +
                "/" +
                poiData.id;
              self.currentPoiLayer = poiData.layer ? poiData.layer.id : null;
              self.currentPoiType = poiData.type ? poiData.type.id : null;

              if (poiData.type && poiData.type.structure) {
                self.poiForm = JSON.parse(poiData.type.structure);
              } else {
                // POI has no type or type was deleted — load form from poitypes if possible
                console.warn(
                  "POI has no type or type.structure is missing, poi:",
                  poi.id,
                );
                if (self.currentPoiType) {
                  const fallbackType = self.poitypes.find(
                    (pt) => pt.id === self.currentPoiType,
                  );
                  if (fallbackType && fallbackType.structure) {
                    self.poiForm = JSON.parse(fallbackType.structure);
                  } else {
                    self.poiForm = {};
                  }
                } else {
                  self.poiForm = {};
                }
              }
              self.poiID = poi.id;
              self.currentMarker.position.latitude = marker.latitude;
              self.currentMarker.position.longitude = marker.longitude;
              poiData.data = JSON.parse(poiData.data);
              self.currentMarkers.push({
                index: index,
                layer: layer,
                position: {
                  latitude: marker.latitude,
                  longitude: marker.longitude,
                },
                data: JSON.parse(JSON.stringify(poiData.data)),
                poiID: poi.id,
              });
              if (poiData.data) {
                self.poiFiles = poiData.files || [];
                self.poiFormPanel.open();
                setTimeout(() => {
                  self.poiData =
                    self.currentMarkers.length > 1
                      ? self.currentMarkers.map((currentMarker) =>
                          JSON.parse(JSON.stringify(currentMarker.data)),
                        )
                      : poiData.data;
                }, 0);
              } else {
                throw "Data of poi not present";
              }
            } else {
              throw "Data of poi not present";
            }
          } catch (e) {
            console.log(e);
            self.resetCurrentMarker();
          }
        })
        .catch((err) => {
          console.log(err);
          self.logger.error(err);
          self.resetCurrentMarker();
        });
    }
  }

  private loadAllFromLayerBounded(
    layer: object,
    organization: string,
    maxLatitude: number,
    maxLongitude: number,
    minLatitude: number,
    minLongitude: number,
    nextToken?: string,
  ) {
    let self = this;
    if (layer && layer["id"]) {
      self.citiesService
        .getAllPoiFromCityBounded(
          layer["id"],
          organization,
          maxLatitude,
          maxLongitude,
          minLatitude,
          minLongitude,
          nextToken,
        )
        .then((data) => {
          self._handlePoiLayerResponse(
            data,
            layer,
            organization,
            maxLatitude,
            maxLongitude,
            minLatitude,
            minLongitude,
            true,
          );
        })
        .catch((err) => {
          self._handlePoiLayerResponse(
            err,
            layer,
            organization,
            maxLatitude,
            maxLongitude,
            minLatitude,
            minLongitude,
            false,
          );
        });
    }
  }

  private _handlePoiLayerResponse(
    response: any,
    layer: object,
    organization: string,
    maxLatitude: number,
    maxLongitude: number,
    minLatitude: number,
    minLongitude: number,
    isSuccess: boolean,
  ) {
    let self = this;
    const poiLayer = response && response.data && response.data.getPoiLayer;
    if (poiLayer && poiLayer.poi && poiLayer.poi.items) {
      const validItems = poiLayer.poi.items.filter((item: any) => item != null);
      layer["poi"]["items"] = layer["poi"]["items"].concat(validItems);
      if (poiLayer.poi.nextToken) {
        self.loadAllFromLayerBounded(
          layer,
          organization,
          maxLatitude,
          maxLongitude,
          minLatitude,
          minLongitude,
          poiLayer.poi.nextToken,
        );
      }
    } else if (!isSuccess) {
      self.logger.error(response);
    }
  }

  private loadAllFromLayer(
    layer: object,
    organization: string,
    nextToken?: string,
  ) {
    let self = this;
    if (layer && layer["id"]) {
      self.citiesService
        .getAllPoiFromCity(layer["id"], organization, nextToken)
        .then((data) => {
          if (
            data &&
            data.data &&
            data.data.getPoiLayer &&
            data.data.getPoiLayer.poi &&
            data.data.getPoiLayer.poi.items
          ) {
            layer["poi"]["items"] = layer["poi"]["items"].concat(
              data.data.getPoiLayer.poi.items,
            );
          }
          if (
            data &&
            data.data &&
            data.data.getPoiLayer &&
            data.data.getPoiLayer.poi &&
            data.data.getPoiLayer.poi.nextToken
          ) {
            self.loadAllFromLayer(
              layer,
              organization,
              data.data.getPoiLayer.poi.nextToken,
            );
          }
        })
        .catch((err) => {
          self.logger.error(err);
        });
    }
  }

  private loadRemote(id, organization, data?: boolean) {
    let self = this;
    self.citiesService
      .getLayersFromCity(id, organization)
      .then((data) => {
        if (
          data &&
          data.data &&
          data.data.getCities &&
          data.data.getCities.layers &&
          data.data.getCities.layers.items &&
          data.data.getCities.layers.items.length > 0
        ) {
          self.poilayers = data.data.getCities.layers.items;
          for (let layer of data.data.getCities.layers.items) {
            layer.poi = {};
            layer.poi.items = [];
            //self.loadAllFromLayer(layer, organization);
          }

          self.poilayers.sort((a, b) => {
            if (a.kmlkmz && !b.kmlkmz) {
              return -1;
            }
            if (!a.kmlkmz && b.kmlkmz) {
              return 1;
            }
            return 0;
          });
        }
      })
      .catch((err) => {
        self.logger.error(err);
      });
  }

  private addFilterGroup() {
    let self = this;
    self.filtersGroups.push({
      groupIndex: self.filtersGroups.length + 1,
      filters: [],
      color: null,
      hide: false,
      active: true,
      customicon: null,
    });
    self.addRandomColors();
  }

  private addFilter() {
    let self = this;
    self.filtersGroups[self.filter_group - 1].filters.push({
      poitype: self.filter_object,
      column: self.filter_column,
      operator: self.filter_operator,
      value: self.filter_value,
      customicon: null,
    });
  }

  private deleteFilter(filtersGroup, filter) {
    let self = this,
      index = 0;
    filtersGroup.filters.forEach((filteri) => {
      if (filter == filteri) {
        filtersGroup.filters.splice(index, 1);
      }
      index++;
    });
  }

  private deleteFilterGroup(filtergroup) {
    let self = this;
    const index = self.filtersGroups.findIndex(
      (g) => g.groupIndex === parseInt(filtergroup),
    );
    if (index !== -1) self.filtersGroups.splice(index, 1);
  }

  private showhideFilterGroup(filtergroup) {
    let self = this;
    const index = self.filtersGroups.findIndex(
      (g) => g.groupIndex === parseInt(filtergroup),
    );
    if (index !== -1)
      self.filtersGroups[index].hide = !self.filtersGroups[index].hide;
  }

  private getOptionLabel(options, value) {
    const opt = options.find((o) => o.value == value);
    return opt ? opt.label : value;
  }

  private loadCity() {
    let self = this,
      poiNextToken = null;
    try {
      if (self.currentCity && self.user) {
        self.mapCenter.latitude = self.currentCity.position_lat;
        self.mapCenter.longitude = self.currentCity.position_lng;
        self.mapCenter.zoom = 12;
        self.poilayers = [];

        self.loadRemote(self.currentCity.id, self.user.organization, true);

        var borders = self.currentCity.area
          .toString()
          .replace(/['"]+/g, "")
          .split(" ");
        var bordersCoords = [];

        borders.forEach((border) => {
          var borderCord = border.toString().split(",");
          var latitude = parseFloat(borderCord[1]);
          var longitude = parseFloat(borderCord[0]);
          if (borderCord && borderCord.length > 2 && latitude && longitude)
            bordersCoords.push({ lat: latitude, lng: longitude });
        });
        if (self.borderPolygon) self.borderPolygon.setMap(null);
        self.borderPolygon = new google.maps.Polygon({
          paths: bordersCoords,
          strokeColor: "#3a539b",
          strokeOpacity: 1,
          strokeWeight: 4,
          fillColor: "#FFF",
          fillOpacity: 0,
          zIndex: -999,
          clickable: false,
          draggable: false,
          editable: false,
        });
        self.borderPolygon.setMap(self.map);
      }
    } catch (e) {
      console.log(e);
    }
  }

  changeCity(city) {
    let self = this;
    self.currentCity = city.value ? city.value : null;
    self.defaultPoiLayer = null;
    self.currentPoiLayer = null;
    self.filter_object = null;
    self.filter_column = null;
    self.filter_operator = null;
    self.filter_value = null;
    self.filter_group = null;
    self.filtersGroups = [
      {
        groupIndex: 1,
        filters: [
          {
            column: {
              label: "Post owner",
              prop: "post_owner",
              type: "radio",
              value: "0",
              options: [
                {
                  label: "Municipal or public",
                  value: "0",
                },
                {
                  label: "EnelSole",
                  value: "1",
                },
                {
                  label: "Project",
                  value: "2",
                },
                {
                  label: "Other",
                  value: "999",
                },
              ],
            },
            operator: 0,
            poitype: {
              id: "aab85a6b-582a-4f2c-a865-84201db5e051",
              name: "lighting",
            },
            value: "0",
          },
        ],
        color: "rgb(56,103,214)",
        hide: false,
        active: true,
        customicon: null,
      },
      {
        groupIndex: 2,
        filters: [
          {
            column: {
              label: "Post owner",
              prop: "post_owner",
              type: "radio",
              value: "0",
              options: [
                {
                  label: "Municipal or public",
                  value: "0",
                },
                {
                  label: "EnelSole",
                  value: "1",
                },
                {
                  label: "Project",
                  value: "2",
                },
                {
                  label: "Other",
                  value: "999",
                },
              ],
            },
            operator: 0,
            poitype: {
              id: "aab85a6b-582a-4f2c-a865-84201db5e051",
              name: "lighting",
            },
            value: "1",
          },
        ],
        color: "rgb(235,59,90)",
        hide: false,
        active: true,
        customicon: null,
      },
      {
        groupIndex: 3,
        filters: [
          {
            column: {
              label: "Post owner",
              prop: "post_owner",
              type: "radio",
              value: "0",
              options: [
                {
                  label: "Municipal or public",
                  value: "0",
                },
                {
                  label: "EnelSole",
                  value: "1",
                },
                {
                  label: "Project",
                  value: "2",
                },
                {
                  label: "Other",
                  value: "999",
                },
              ],
            },
            operator: 0,
            poitype: {
              id: "aab85a6b-582a-4f2c-a865-84201db5e051",
              name: "lighting",
            },
            value: "999",
          },
        ],
        color: "rgb(254,211,48)",
        hide: false,
        active: true,
        customicon: null,
      },
      {
        groupIndex: 4,
        filters: [
          {
            column: {
              label: "Post owner",
              prop: "post_owner",
              type: "radio",
              value: "0",
              options: [
                {
                  label: "Municipal or public",
                  value: "0",
                },
                {
                  label: "EnelSole",
                  value: "1",
                },
                {
                  label: "Project",
                  value: "2",
                },
                {
                  label: "Other",
                  value: "999",
                },
              ],
            },
            operator: 0,
            poitype: {
              id: "aab85a6b-582a-4f2c-a865-84201db5e051",
              name: "lighting",
            },
            value: "2",
          },
        ],
        color: "rgb(38,222,129)",
        hide: false,
        active: true,
        customicon: null,
      },
      {
        groupIndex: 5,
        filters: [
          {
            column: {
              label: "Cabinet owner",
              prop: "cabinet_owner",
              type: "radio",
              value: "0",
              options: [
                {
                  label: "Municipal or public",
                  value: "0",
                },
                {
                  label: "EnelSole",
                  value: "1",
                },
                {
                  label: "Project",
                  value: "2",
                },
                {
                  label: "Other",
                  value: "999",
                },
              ],
            },
            operator: 0,
            poitype: {
              id: "60166f16-2016-458f-92a4-16a51015134a",
              name: "cabinet",
            },
            value: "0",
          },
        ],
        color: "rgb(56,103,214)",
        hide: false,
        active: true,
        customicon: null,
      },
      {
        groupIndex: 6,
        filters: [
          {
            column: {
              label: "Cabinet owner",
              prop: "cabinet_owner",
              type: "radio",
              value: "0",
              options: [
                {
                  label: "Municipal or public",
                  value: "0",
                },
                {
                  label: "EnelSole",
                  value: "1",
                },
                {
                  label: "Project",
                  value: "2",
                },
                {
                  label: "Other",
                  value: "999",
                },
              ],
            },
            operator: 0,
            poitype: {
              id: "60166f16-2016-458f-92a4-16a51015134a",
              name: "cabinet",
            },
            value: "1",
          },
        ],
        color: "rgb(235,59,90)",
        hide: false,
        active: true,
        customicon: null,
      },
      {
        groupIndex: 7,
        filters: [
          {
            column: {
              label: "Cabinet owner",
              prop: "cabinet_owner",
              type: "radio",
              value: "0",
              options: [
                {
                  label: "Municipal or public",
                  value: "0",
                },
                {
                  label: "EnelSole",
                  value: "1",
                },
                {
                  label: "Project",
                  value: "2",
                },
                {
                  label: "Other",
                  value: "999",
                },
              ],
            },
            operator: 0,
            poitype: {
              id: "60166f16-2016-458f-92a4-16a51015134a",
              name: "cabinet",
            },
            value: "999",
          },
        ],
        color: "rgb(254,211,48)",
        hide: false,
        active: true,
        customicon: null,
      },
      {
        groupIndex: 8,
        filters: [
          {
            column: {
              label: "Cabinet owner",
              prop: "cabinet_owner",
              type: "radio",
              value: "0",
              options: [
                {
                  label: "Municipal or public",
                  value: "0",
                },
                {
                  label: "EnelSole",
                  value: "1",
                },
                {
                  label: "Project",
                  value: "2",
                },
                {
                  label: "Other",
                  value: "999",
                },
              ],
            },
            operator: 0,
            poitype: {
              id: "60166f16-2016-458f-92a4-16a51015134a",
              name: "cabinet",
            },
            value: "2",
          },
        ],
        color: "rgb(38,222,129)",
        hide: false,
        active: true,
        customicon: null,
      },
    ];
    self.loadCity();
  }

  constructor(
    private httpService: HttpClient,
    private translateService: TranslateService,
    private poiService: PoiService,
    private layerService: LayerService,
    private userService: UserService,
    private citiesService: CitiesService,
    private amplifyService: AmplifyService,
    private logger: LoggerService,
    private locationsService: LocationsService,
    private geolocationService: GeolocationService,
    private snackbar: MatSnackBar,
    private route: ActivatedRoute,
    private router: Router,
    public dialog: MatDialog,
    private ngZone: NgZone,
  ) {
    let self = this;

    /*
        self.userService.getCurrentUser().then(user => {
          self.user = user;
          self.poiService.getMinePoiTypeId().then(organizationPoiTypesId => {
            Object.keys(organizationPoiTypesId).forEach(key => {
              self.poiService.getType(organizationPoiTypesId[key]).then(poiType => {
                self.poitypes.push(poiType.data.getPoiType);
              }).catch(err => {
                console.log(err);
              });
            });
            if (self.user && self.user.attributes && self.user.attributes["custom:preferencies"]) {
              let preferencies = JSON.parse(self.user.attributes["custom:preferencies"]);
              Object.keys(preferencies).forEach(key => {
                self.userPreferencies[key] = preferencies[key];
              });
            }
          }).catch(err => {
            console.log(err);
          });

          self.geolocationService.getLocation({
            enableHighAccuracy: false,
            maximumAge: 0
          }).subscribe(
            function (position) {
              if (position && position.coords) self.locationsService.create(self.user.username, self.user.organization, position.coords.latitude, position.coords.longitude, 0, {});
            },
            function (error) {
              console.log(error);
            }
          );

        }).catch(err => {
          console.log(err);
        });*/

    /*self.locationsService.subscribe(function (data) {
      if (data && data.value && data.value.data && data.value.data.onCreateLocations && data.value.data.onCreateLocations.id) {
        self.locationsService.get(data.value.data.onCreateLocations.id)
          .then(data => {
            if (data && data.data && data.data.getLocations) {
              if (data.data.getLocations.organizationID == self.user.organization) {
                if (self.colleagues[data.data.getLocations.user]) {
                  self.colleagues[data.data.getLocations.user].position_lat = data.data.getLocations.position_lat;
                  self.colleagues[data.data.getLocations.user].position_lng = data.data.getLocations.position_lng;
                } else {
                  self.colleagues[data.data.getLocations.user] = data.data.getLocations;
                  self.userService.getUser(data.data.getLocations.user).then(user => {
                    if (user && user["UserAttributes"] && user["UserAttributes"].length > 0) {
                      for (var attribute of user["UserAttributes"]) {
                        if (attribute.Name == "custom:avatar") {
                          self.colleagues[data.data.getLocations.user]["avatar"] = "https://s3-eu-west-1.amazonaws.com/egaiaassets/public/" + attribute.Value;
                          self.colleaguesIcons[data.data.getLocations.user] = {
                            markerType: MarkerTypeId.RoundedImageMarker,
                            url: "https://s3-eu-west-1.amazonaws.com/egaiaassets/public/" + attribute.Value,
                            size: { width: 50, height: 50 },
                            markerOffsetRatio: { x: 0.5, y: 0.5 }
                          };
                          return true;
                        }
                      }
                    }
                  });
                }
              }
            }
          }).catch(err => {
            console.log(err);
          });
      }
    });*/

    self.poiServiceSubscription = self.poiService.subscribe(function (data) {
      if (
        data &&
        data.value &&
        data.value.data &&
        data.value.data.onCreatePoi &&
        data.value.data.onCreatePoi.id
      ) {
        if (self.lastInsertedPoi != data.value.data.onCreatePoi.id) {
          self.poiService
            .get(data.value.data.onCreatePoi.id)
            .then((data) => {
              try {
                if (
                  data &&
                  data.data &&
                  data.data.getPoi &&
                  data.data.getPoi.city &&
                  data.data.getPoi.city.id &&
                  data.data.getPoi.organizationID &&
                  data.data.getPoi.layer &&
                  data.data.getPoi.layer.id
                ) {
                  if (
                    self.currentCity.id == data.data.getPoi.city.id &&
                    self.user.organization == data.data.getPoi.organizationID
                  ) {
                    self.poilayers.forEach((poilayer) => {
                      if (poilayer.id == data.data.getPoi.layer.id) {
                        poilayer.poi.items.push({
                          id: data.data.getPoi.id ? data.data.getPoi.id : null,
                          data: data.data.getPoi.data
                            ? JSON.parse(data.data.getPoi.data)
                            : null,
                          type: { name: data.data.getPoi.type.name },
                          position_flr: data.data.getPoi.position_flr
                            ? data.data.getPoi.position_flr
                            : 0,
                          position_lat: data.data.getPoi.position_lat
                            ? data.data.getPoi.position_lat
                            : 0,
                          position_lng: data.data.getPoi.position_lng
                            ? data.data.getPoi.position_lng
                            : 0,
                        });
                        if (
                          self.userPreferencies &&
                          self.userPreferencies["notifynewpoints"] &&
                          self.userPreferencies["notifynewpoints"] == "y"
                        )
                          self.snackbar.open(
                            data.data.getPoi.owner + " added new poi",
                            "ok",
                            { duration: 2000, panelClass: ["white-snackbar"] },
                          );
                      }
                    });
                  }
                }
              } catch (e) {
                console.log(e);
              }
            })
            .catch((err) => {
              console.log(err);
            });
        }
      }
    });
  }

  changePoiType(event) {
    let self = this;
    if (event && event.value) {
      self.poitypes.forEach((poitype) => {
        if (poitype.id === event.value) {
          self.currentPoiType = poitype.id;
          if (poitype.structure) {
            try {
              self.poiForm = JSON.parse(poitype.structure);
            } catch (e) {
              console.error(
                "[changePoiType] invalid structure for type:",
                poitype.id,
                e,
              );
              self.poiForm = {};
            }
          } else {
            self.poiForm = {};
          }
        }
      });
    }
  }

  ngOnInit() {
    let self = this;
    let city = self.route.snapshot.paramMap.get("city");
    let selectedCity = null;

    self.subscriptions.push(
      self.httpService
        .get("https://app2.egaia.net/assets/customicons.json")
        .subscribe(
          (data) => {
            self.customicons = data as string[];
          },
          (err: HttpErrorResponse) => {
            self.customicons = [
              {
                ID: "001",
                URI: "https://app2.egaia.net/assets/customicons/001.png",
              },
              {
                ID: "002",
                URI: "https://app2.egaia.net/assets/customicons/002.png",
              },
              {
                ID: "003",
                URI: "https://app2.egaia.net/assets/customicons/003.png",
              },
              {
                ID: "004",
                URI: "https://app2.egaia.net/assets/customicons/004.png",
              },
              {
                ID: "005",
                URI: "https://app2.egaia.net/assets/customicons/005.png",
              },
              {
                ID: "006",
                URI: "https://app2.egaia.net/assets/customicons/006.png",
              },
              {
                ID: "007",
                URI: "https://app2.egaia.net/assets/customicons/007.png",
              },
              {
                ID: "008",
                URI: "https://app2.egaia.net/assets/customicons/008.png",
              },
              {
                ID: "009",
                URI: "https://app2.egaia.net/assets/customicons/009.png",
              },
              {
                ID: "010",
                URI: "https://app2.egaia.net/assets/customicons/010.png",
              },
            ];
          },
        ),
    );

    self.subscriptions.push(
      self.userService.currentuserAvailable.subscribe((data) => {
        if (data) {
          self.user = self.userService.currentUser;
          self.cities = self.user.activecities.sort((a, b) =>
            a.name
              .toString()
              .toLowerCase()
              .localeCompare(b.name.toString().toLowerCase()),
          );
          self.poitypes = [];
          const orgPoiTypes = self.user.organizationObject.poiTypes;
          if (
            orgPoiTypes &&
            Array.isArray(orgPoiTypes) &&
            orgPoiTypes.length > 0
          ) {
            orgPoiTypes.forEach((poiTypeId: string) => {
              self.poiService
                .getType(poiTypeId)
                .then((poiType) => {
                  if (poiType && poiType.data && poiType.data.getPoiType) {
                    self.poitypes.push(poiType.data.getPoiType);
                  }
                })
                .catch((err) => {
                  console.log("Error loading poiType:", poiTypeId, err);
                });
            });
          }
          self.subscriptions.push(
            self.route.params.subscribe((params) => {
              self.cities.forEach((city) => {
                if (city.name == params.city || city.id == params.city) {
                  self.currentCity = city;
                  self.loadCity();
                }
              });
            }),
          );
        }
      }),
    );

    // Inizialize user's position
    this.initializeUserPosition();

    /*        self.route.params.subscribe(params => {
                if (params && params.city && params.city) {
                  self.userService.getCurrentUser().then(data => {
                    self.cities.forEach(city => {
                      if (city.name == params.city || city.id == params.city) {
                        self.currentCity = city;
                        self.loadCity();
                        if (params.poi) {
                          self.poiService.get(params.poi)
                            .then(data => {
                              try {
                                if (data && data.data && data.data.getPoi) {
                                  var poiData = data.data.getPoi;
                                  self.poiQrcode = "https://app2.egaia.net/Dashboard/" + self.currentCity.id + "/" + poiData.id;
                                  self.currentPoiLayer = (poiData.layer) ? poiData.layer.id : null;
                                  self.currentPoiType = (poiData.type) ? poiData.type.id : null;
                                  self.poiForm = JSON.parse(poiData.type.structure);
                                  self.poiID = params.poi;
                                  self.currentMarker.position.latitude = poiData.position_lat;
                                  self.currentMarker.position.longitude = poiData.position_lng;
                                  poiData.data = JSON.parse(poiData.data);
                                  if (poiData.data) {
                                    self.poiData = poiData.data;
                                    self.poiFiles = poiData.files;
                                    self.poiFormPanel.open();
                                  } else {
                                    throw "Data of poi not present";
                                  }
                                } else {
                                  throw "Data of poi not present";
                                }
                              } catch (e) {
                                self.poiFormPanel.open();
                                self.resetCurrentMarker();
                                self.poiFiles = [];
                              }
                            })
                            .catch(err => {
                              self.logger.error(err);
                            });
                        }
                      }
                    });
                  });
                }
              });
            });
          })
          .catch(err => {
            self.logger.error(err);
          });*/
  }

  private moveToCurrentPosition() {
    let self = this;
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        function (position) {
          self.ngZone.run(() => {
            self.mapCenter.latitude = position.coords.latitude;
            self.mapCenter.longitude = position.coords.longitude;
            self.mapCenter.zoom = 15;
          });
        },
        function (error) {
          console.log("Geolocation error", error.code);
        },
      );
    }
  }

  private changePoiLayer(event) {
    const targetLayerId = event && event.value;
    if (
      !targetLayerId ||
      this.poiAction !== "adding" ||
      this.currentMarkers.length !== 1
    ) {
      return;
    }

    this.movePoiMarkerToLayer(this.currentMarkers[0], targetLayerId);
  }

  private movePoiMarkerToLayer(marker, targetLayerId) {
    if (
      !marker ||
      !this.isNumeric(marker.layer) ||
      !this.isNumeric(marker.index)
    ) {
      return;
    }

    const sourceLayerIndex = marker.layer;
    const sourcePoiIndex = marker.index;
    const targetLayerIndex = this.poilayers.findIndex(
      (layer) => layer && layer.id === targetLayerId,
    );
    if (targetLayerIndex < 0 || targetLayerIndex === sourceLayerIndex) return;

    const sourceLayer = this.poilayers[sourceLayerIndex];
    const targetLayer = this.poilayers[targetLayerIndex];
    if (
      !sourceLayer ||
      !sourceLayer.poi ||
      !sourceLayer.poi.items ||
      !sourceLayer.poi.items[sourcePoiIndex]
    ) {
      return;
    }

    if (!targetLayer.poi) targetLayer.poi = { items: [] };
    if (!targetLayer.poi.items) targetLayer.poi.items = [];

    const poi = sourceLayer.poi.items.splice(sourcePoiIndex, 1)[0];
    poi.current = true;
    targetLayer.poi.items.push(poi);

    const targetPoiIndex = targetLayer.poi.items.length - 1;
    marker.layer = targetLayerIndex;
    marker.index = targetPoiIndex;

    if (
      this.currentMarker.layer === sourceLayerIndex &&
      this.currentMarker.index === sourcePoiIndex
    ) {
      this.currentMarker.layer = targetLayerIndex;
      this.currentMarker.index = targetPoiIndex;
    }

    if (!this.selectedPoiLayers.includes(targetLayer)) {
      this.selectedPoiLayers.push(targetLayer);
    }
  }

  private poiUndo() {
    let self = this;
    switch (self.poiAction) {
      case "editing":
        self.poiFormPanel.close();
        self.poiFiles = [];
        self.poiData = null;
        if (self.poiID && self.poiOriginalData) {
          self.currentMarker.position.latitude =
            self.poiOriginalData.position.latitude;
          self.currentMarker.position.longitude =
            self.poiOriginalData.position.longitude;
          self.currentMarker.marker.Latitude =
            self.poiOriginalData.position.latitude;
          self.currentMarker.marker.Longitude =
            self.poiOriginalData.position.longitude;
          self.poilayers[self.currentMarker.layer].poi.items[
            self.currentMarker.index
          ].position_lat = self.poiOriginalData.position.latitude;
          self.poilayers[self.currentMarker.layer].poi.items[
            self.currentMarker.index
          ].position_lng = self.poiOriginalData.position.longitude;
          self.poiOriginalData = null;
        }
        self.poiID = null;
        if (
          self.currentMarker.index === null &&
          self.currentMarker.layer === null &&
          typeof self.poilayers[self.poilayers.length - 1].name === "undefined"
        ) {
          self.poilayers[self.poilayers.length - 1].poi.items = [];
          self.poilayers = self.poilayers.slice(0, self.poilayers.length - 1);
        }
        break;
      case "adding":
        self.poiFormPanel.close();
        self.poiFiles = [];
        if (
          self.currentMarker.index === null &&
          self.currentMarker.layer === null &&
          typeof self.poilayers[self.poilayers.length - 1].name === "undefined"
        ) {
          self.poilayers[self.poilayers.length - 1].poi.items = [];
          self.poilayers = self.poilayers.slice(0, self.poilayers.length - 1);
        } else {
          if (
            self.poilayers[self.currentMarker.layer] &&
            self.poilayers[self.currentMarker.layer].poi &&
            self.poilayers[self.currentMarker.layer].poi.items
          ) {
            self.poilayers[self.currentMarker.layer].poi.items = self.poilayers[
              self.currentMarker.layer
            ].poi.items.slice(
              0,
              self.poilayers[self.currentMarker.layer].poi.items.length - 1,
            );
          }
        }
        self.poiID = null;
        break;
    }
    self.resetCurrentMarker();
  }

  private poiDeleteFile(event) {
    let self = this;
    if (event) {
      var filename = event
        .toString()
        .replace("https://s3-eu-west-1.amazonaws.com/egaiaassets/public/", "");
      Storage.remove(filename)
        .then((result) => {
          var fileindex = self.poiFiles.indexOf(event);
          if (self.isNumeric(fileindex)) self.poiFiles.splice(fileindex, 1);
        })
        .catch((err) => console.log(err));
    }
  }

  private poiUpload(data) {
    let self = this;
    if (data && data.target && data.target.files) {
      var filename =
        "data/" +
        self.user.organization +
        "/" +
        self.currentCity.id +
        "/" +
        uuid() +
        "." +
        data.target.files[0].name.split(".").pop();
      Storage.put(filename, data.target.files[0], {
        contentType: data.target.files[0].type,
        level: "public",
        ACL: "public-read",
      })
        .then((result) => {
          if (result && result["key"]) {
            if (!self.poiFiles) self.poiFiles = [];
            self.poiFiles.push(
              "https://s3-eu-west-1.amazonaws.com/egaiaassets/public/" +
                result["key"],
            );
          }
        })
        .catch((err) => self.logger.error(err));
    }
  }

  private poiRecenter() {
    let self = this;
    if (
      navigator.geolocation &&
      self.currentMarker &&
      self.isNumeric(self.currentMarker.index) &&
      self.isNumeric(self.currentMarker.layer)
    ) {
      navigator.geolocation.getCurrentPosition(
        function (position) {
          self.ngZone.run(() => {
            self.currentMarker.position.latitude = position.coords.latitude;
            self.currentMarker.position.longitude = position.coords.longitude;
            self.poilayers[self.currentMarker.layer].poi.items[
              self.currentMarker.index
            ].position_lat = position.coords.latitude;
            self.poilayers[self.currentMarker.layer].poi.items[
              self.currentMarker.index
            ].position_lng = position.coords.longitude;
            self.mapCenter.latitude = position.coords.latitude;
            self.mapCenter.longitude = position.coords.longitude;
            self.mapCenter.zoom = 16;
          });
        },
        function (error) {
          console.log("Geolocation error", error.code);
        },
      );
    }
  }

  private poiResetFields() {
    let self = this;
    self.poiDataUpdates = {
      notes: " ",
      project_notes: " ",
      rotosymmetric_optical_installation_pictures: " ",
      collar_makeover_pictures: " ",
      galvanization_pictures: " ",
      gardeding_operation_pictures: " ",
      outreach_painting_pictures: " ",
      outreach_replacement_pictures: " ",
      post_status_pictures: " ",
      rust_pictures: " ",
      terminalboard_makeover_pictures: " ",
      pictures: " ",
      collar_makeover: 0,
      galvanization: 0,
      gardeding_operation: 0,
      intervention_images: " ",
      outreach_painting: 0,
      outreach_replacement: 0,
      post_painting: 0,
      post_replacement: 0,
      post_status: 0,
      rust: 0,
      terminalboard_makeover: 0,
    };
  }

  private buildPreservedPoiDataForAddNew(data) {
    const preserved = {};
    if (!data) return preserved;

    Object.keys(data).forEach((key) => {
      if (key === "addnew" || key === "dirtyFields" || key === "poiID") return;
      preserved[key] = data[key];
    });

    return preserved;
  }

  ngOnDestroy() {
    this.subscriptions.forEach((s) => s.unsubscribe());
    if (this.poiServiceSubscription) this.poiServiceSubscription.unsubscribe();
  }

  private changePoiTypeFilter(event) {
    let self = this;
    if (event && event.value && event.value.structure) {
      var structure = JSON.parse(event.value.structure);
      self.poitypestructure = [];
      Object.keys(structure).forEach((structuregroup) => {
        Object.keys(structure[structuregroup]["items"]).forEach((item) => {
          structure[structuregroup]["items"][item].prop = item;
          self.poitypestructure.push(structure[structuregroup]["items"][item]);
        });
      });
    }
  }

  private poiAdd(position, preservedData = null, preserveCurrentLayer = false) {
    let self = this;
    const selectedLayerId = preserveCurrentLayer
      ? self.currentPoiLayer
      : self.defaultPoiLayer;
    const selectedLayerExists = self.poilayers.some(
      (layer) => layer && layer.id === selectedLayerId,
    );

    // A new POI must always have an explicitly selected valid layer.
    if (!selectedLayerExists) {
      self.currentPoiLayer = null;
      self.snackbar.open(
        "Seleziona un livello prima di inserire un nuovo punto luce",
        "ok",
        { duration: 3000, panelClass: ["white-snackbar"] },
      );
      return;
    }

    self.currentPoiLayer = selectedLayerId;

    // Reset current marker
    self.resetCurrentMarker();
    self.poitypeLocked = false;
    self.poiAction = "adding";
    self.poiFiles = [];
    self.poiData = preservedData ? { ...preservedData } : {};

    // Pre-load form structure if a type is already selected
    if (self.currentPoiType) {
      const existingType = self.poitypes.find(
        (pt) => pt.id === self.currentPoiType,
      );
      if (existingType && existingType.structure) {
        self.poiForm = JSON.parse(existingType.structure);
      }
    }

    // If no valid form structure, try to auto-select a type
    // Fallback to first type if no valid form structure
    if (!self.poiForm || Object.keys(self.poiForm).length === 0) {
      if (self.poitypes.length > 0) {
        const firstType = self.poitypes[0];
        self.currentPoiType = firstType.id;
        if (firstType.structure) {
          self.poiForm = JSON.parse(firstType.structure);
        }
      }
    }

    if (self.numberingHistory && self.numberingHistory.length > 1) {
      if (self.userPreferencies && self.userPreferencies["poinumbercalc"]) {
        if (self.userPreferencies["poinumbercalc"] == "i")
          self.poiData.post_number =
            self.numberingHistory[1] +
            (self.numberingHistory[1] - self.numberingHistory[0]);
        else
          self.poiData.post_number =
            self.numberingHistory[1] +
              (self.numberingHistory[1] - self.numberingHistory[0]) >
            0
              ? self.numberingHistory[1] + 1
              : self.numberingHistory[1] - 1;
      } else {
        self.poiData.post_number =
          self.numberingHistory[1] +
            (self.numberingHistory[1] - self.numberingHistory[0]) >
          0
            ? self.numberingHistory[1] + 1
            : self.numberingHistory[1] - 1;
      }
    }

    // Calculate the interdistance
    if (self.interdistanceHistory && self.interdistanceHistory.length > 1)
      self.poiData.post_interdistance = self.distance(
        self.interdistanceHistory[0].lat,
        self.interdistanceHistory[0].lng,
        self.interdistanceHistory[1].lat,
        self.interdistanceHistory[1].lng,
      );

    if (navigator.geolocation) {
      switch (position) {
        case "myPosition":
          navigator.geolocation.getCurrentPosition(
            function (position) {
              self.ngZone.run(() => {
                if (self.lastTwoPois[0]) {
                  self.lastTwoPois[1] = {
                    lat: self.lastTwoPois[0].lat,
                    lng: self.lastTwoPois[0].lng,
                  };
                }
                self.lastTwoPois[0] = {
                  lat: position.coords.latitude,
                  lng: position.coords.longitude,
                };
                self.currentMarker.position.latitude = self.lastTwoPois[0].lat;
                self.currentMarker.position.longitude = self.lastTwoPois[0].lng;
                self.mapCenter.latitude = self.lastTwoPois[0].lat;
                self.mapCenter.longitude = self.lastTwoPois[0].lng;
                self.mapCenter.zoom = 16;
                let layerFound = false;
                if (selectedLayerId) {
                  for (var i = 0; i < self.poilayers.length; i++) {
                    if (self.poilayers[i].id == selectedLayerId) {
                      if (!self.poilayers[i].poi)
                        self.poilayers[i].poi = { items: [] };
                      self.poilayers[i].poi.items.push({
                        id: null,
                        position_flr: 0,
                        position_lat: self.currentMarker.position.latitude,
                        position_lng: self.currentMarker.position.longitude,
                        current: true,
                        data: null,
                        type: null,
                      });
                      self.currentMarker.index =
                        self.poilayers[i].poi.items.length - 1;
                      self.currentMarker.layer = i;
                      self.currentPoiLayer = self.poilayers[i].id;
                      layerFound = true;
                    }
                  }
                }
                if (!layerFound) {
                  if (self.poilayers.length === 0) {
                    self.poilayers.push({ poi: { items: [] } });
                  }
                  const targetLayer = self.poilayers[self.poilayers.length - 1];
                  if (!targetLayer.poi) targetLayer.poi = { items: [] };
                  targetLayer.poi.items.push({
                    id: null,
                    position_flr: 0,
                    position_lat: self.currentMarker.position.latitude,
                    position_lng: self.currentMarker.position.longitude,
                    current: true,
                    data: null,
                    type: null,
                  });
                  self.currentMarker.index = targetLayer.poi.items.length - 1;
                  self.currentMarker.layer = self.poilayers.length - 1;
                  self.currentPoiLayer = targetLayer.id || null;
                }
                if (self.isNumeric(self.currentMarker.layer)) {
                  const newLayer = self.poilayers[self.currentMarker.layer];
                  if (newLayer && !self.selectedPoiLayers.includes(newLayer)) {
                    self.selectedPoiLayers.push(newLayer);
                  }
                }
                self.poiFormPanel.open();
                self.poiResetFields();
              });
            },
            function (error) {
              console.log("Geolocation error", error.code);
            },
          );
          break;
        case "mapCenter":
          if (self.lastTwoPois[0]) {
            self.lastTwoPois[1] = {
              lat: self.lastTwoPois[0].lat,
              lng: self.lastTwoPois[0].lng,
            };
          }
          self.lastTwoPois[0] = {
            lat: self.map.center.lat(),
            lng: self.map.center.lng(),
          };
          self.currentMarker.position.latitude = self.lastTwoPois[0].lat;
          self.currentMarker.position.longitude = self.lastTwoPois[0].lng;
          self.mapCenter.latitude = self.lastTwoPois[0].lat;
          self.mapCenter.longitude = self.lastTwoPois[0].lng;
          self.mapCenter.zoom = 16;

          if (selectedLayerId) {
            for (var i = 0; i < self.poilayers.length; i++) {
              if (self.poilayers[i].id == selectedLayerId) {
                if (!self.poilayers[i].poi)
                  self.poilayers[i].poi = { items: [] };
                self.poilayers[i].poi.items.push({
                  id: null,
                  position_flr: 0,
                  position_lat: self.lastTwoPois[0].lat,
                  position_lng: self.lastTwoPois[0].lng,
                  current: true,
                  data: null,
                  type: null,
                });
                self.currentMarker.index =
                  self.poilayers[i].poi.items.length - 1;
                self.currentMarker.layer = i;
                self.currentPoiLayer = self.poilayers[i].id;
              }
            }
          } else {
            if (self.poilayers.length === 0) {
              self.poilayers.push({ poi: { items: [] } });
            }
            const targetLayer = self.poilayers[self.poilayers.length - 1];
            if (!targetLayer.poi) targetLayer.poi = { items: [] };
            targetLayer.poi.items.push({
              id: null,
              position_flr: 0,
              position_lat: self.lastTwoPois[0].lat,
              position_lng: self.lastTwoPois[0].lng,
              current: true,
              data: null,
              type: null,
            });
            self.currentMarker.index = targetLayer.poi.items.length - 1;
            self.currentMarker.layer = self.poilayers.length - 1;
            self.currentPoiLayer = targetLayer.id || null;
          }
          // Always ensure the layer containing the new marker is visible
          if (self.isNumeric(self.currentMarker.layer)) {
            const newLayer = self.poilayers[self.currentMarker.layer];
            if (newLayer && !self.selectedPoiLayers.includes(newLayer)) {
              self.selectedPoiLayers.push(newLayer);
            }
          }
          self.poiFormPanel.open();
          self.poiResetFields();
          break;
        case "sequentially":
          if (self.lastTwoPois.length > 1) {
            self.lastPoiSequentially = {
              lat: 2 * self.lastTwoPois[0].lat - self.lastTwoPois[1].lat,
              lng: 2 * self.lastTwoPois[0].lng - self.lastTwoPois[1].lng,
            };
            self.lastTwoPois[1] = {
              lat: self.lastTwoPois[0].lat,
              lng: self.lastTwoPois[0].lng,
            };
            self.lastTwoPois[0] = {
              lat: self.lastPoiSequentially.lat,
              lng: self.lastPoiSequentially.lng,
            };
            self.currentMarker.position.latitude = self.lastTwoPois[0].lat;
            self.currentMarker.position.longitude = self.lastTwoPois[0].lng;
            self.mapCenter.latitude = self.lastTwoPois[0].lat;
            self.mapCenter.longitude = self.lastTwoPois[0].lng;
            self.mapCenter.zoom = 16;
            if (selectedLayerId) {
              for (var i = 0; i < self.poilayers.length; i++) {
                if (self.poilayers[i].id == selectedLayerId) {
                  if (!self.poilayers[i].poi)
                    self.poilayers[i].poi = { items: [] };
                  self.poilayers[i].poi.items.push({
                    id: null,
                    position_flr: 0,
                    position_lat: self.lastTwoPois[0].lat,
                    position_lng: self.lastTwoPois[0].lng,
                    current: true,
                    data: null,
                    type: null,
                  });
                  self.currentMarker.index =
                    self.poilayers[i].poi.items.length - 1;
                  self.currentMarker.layer = i;
                  self.currentPoiLayer = self.poilayers[i].id;
                }
              }
            } else {
              const seqTargetLayer =
                self.poilayers.length > 0
                  ? self.poilayers[self.poilayers.length - 1]
                  : (() => {
                      const l = { poi: { items: [] } };
                      self.poilayers.push(l);
                      return l;
                    })();
              if (!seqTargetLayer.poi) seqTargetLayer.poi = { items: [] };
              seqTargetLayer.poi.items.push({
                id: null,
                position_flr: 0,
                position_lat: self.lastTwoPois[0].lat,
                position_lng: self.lastTwoPois[0].lng,
                current: true,
                data: null,
                type: null,
              });
              self.currentMarker.index = seqTargetLayer.poi.items.length - 1;
              self.currentMarker.layer = self.poilayers.length - 1;
              self.currentPoiLayer = seqTargetLayer.id || null;
            }
            // Always ensure the layer containing the new marker is visible
            if (self.isNumeric(self.currentMarker.layer)) {
              const newLayer = self.poilayers[self.currentMarker.layer];
              if (newLayer && !self.selectedPoiLayers.includes(newLayer)) {
                self.selectedPoiLayers.push(newLayer);
              }
            }
            self.poiFormPanel.open();
            self.poiResetFields();
          } else {
            self.snackbar.open("Insert almost two pois", "ok", {
              duration: 2000,
              panelClass: ["white-snackbar"],
            });
          }
          break;
      }
    } else {
      self.currentMarker.position.latitude = self.currentCity.position_lat;
      self.currentMarker.position.longitude = self.currentCity.position_lng;
      self.mapCenter.latitude = self.currentCity.position_lat;
      self.mapCenter.longitude = self.currentCity.position_lng;
      self.mapCenter.zoom = 16;
      self.poilayers.push({ poi: { items: [] } });
      self.poilayers[self.poilayers.length - 1].poi.items.push({
        id: null,
        position_flr: 0,
        position_lat: self.currentCity.position_lat,
        position_lng: self.currentCity.position_lng,
        current: true,
        data: null,
        type: null,
      });
      self.currentMarker.index =
        self.poilayers[self.poilayers.length - 1].poi.items.length - 1;
      self.currentMarker.layer = self.poilayers.length - 1;
      // Always ensure the layer containing the new marker is visible
      if (self.isNumeric(self.currentMarker.layer)) {
        const newLayer = self.poilayers[self.currentMarker.layer];
        if (newLayer && !self.selectedPoiLayers.includes(newLayer)) {
          self.selectedPoiLayers.push(newLayer);
        }
      }
      self.poiFormPanel.open();
      self.poiResetFields();
    }
    self.currentMarkers = [
      {
        ...self.currentMarker,
        position: self.currentMarker.position,
      },
    ];
  }

  private getPoiTypeFromId(id: String) {
    for (let poitype of this.poitypes)
      if (poitype.id.toString() == id.toString()) return poitype;
    return null;
  }

  private distance(lat1, lon1, lat2, lon2) {
    let self = this;
    if (lat1 == lat2 && lon1 == lon2) {
      return 0;
    } else {
      var unit = "m";

      if (self.userPreferencies && self.userPreferencies["measureunit"]) {
        unit = self.userPreferencies["measureunit"];
      }

      var radlat1 = (Math.PI * lat1) / 180;
      var radlat2 = (Math.PI * lat2) / 180;
      var theta = lon1 - lon2;
      var radtheta = (Math.PI * theta) / 180;
      var dist =
        Math.sin(radlat1) * Math.sin(radlat2) +
        Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
      if (dist > 1) {
        dist = 1;
      }
      dist = Math.acos(dist);
      dist = (dist * 180) / Math.PI;
      dist = dist * 60 * 1.1515;
      if (unit == "K") {
        dist = dist * 1.609344;
      }
      if (unit == "m") {
        dist = dist * 1.609344 * 1000;
      }
      if (unit == "N") {
        dist = dist * 0.8684;
      }
      return Math.round(dist);
    }
  }

  private merge(obj1, obj2) {
    let answer = {};
    for (let key in obj2) {
      answer[key] = obj2[key];
    }
    for (let key in obj1) {
      answer[key] = obj1[key];
    }
    return answer;
  }

  private showStats() {
    let self = this;

    self.citiesService
      .statistics(self.currentCity.id, self.user.organization)
      .then((data) => {
        if (data && data.data && data.data.poiStatistics) {
          let stats = JSON.parse(data.data.poiStatistics);
          let calcstats = [];
          Object.keys(stats).forEach((stat) => {
            self.poitypes.forEach((poitype) => {
              if (poitype && poitype.hasOwnProperty("name")) {
                if (poitype.id === stat) {
                  calcstats.push({ name: poitype["name"], count: stats[stat] });
                }
              }
            });
          });
          self.dialog.open(StatsDialog, {
            width: "auto",
            data: {
              stats: calcstats,
            },
          });
        }
      });
  }

  private removeUnsavedPoiMarkers(markers) {
    let self = this;
    if (!markers || markers.length === 0) return;

    const markersToRemoveByLayer = {};
    markers.forEach((currentMarker) => {
      if (
        currentMarker &&
        (!currentMarker.poiID || currentMarker.poiID === "") &&
        self.isNumeric(currentMarker.layer) &&
        self.isNumeric(currentMarker.index)
      ) {
        if (!markersToRemoveByLayer[currentMarker.layer])
          markersToRemoveByLayer[currentMarker.layer] = [];
        markersToRemoveByLayer[currentMarker.layer].push(currentMarker.index);
      }
    });

    Object.keys(markersToRemoveByLayer).forEach((layerKey) => {
      const layerIndex = parseInt(layerKey, 10);
      const indexes = markersToRemoveByLayer[layerKey].sort((a, b) => b - a);
      indexes.forEach((itemIndex) => {
        if (
          self.poilayers[layerIndex] &&
          self.poilayers[layerIndex].poi &&
          self.poilayers[layerIndex].poi.items &&
          self.poilayers[layerIndex].poi.items[itemIndex] &&
          !self.poilayers[layerIndex].poi.items[itemIndex].id
        ) {
          self.poilayers[layerIndex].poi.items.splice(itemIndex, 1);
        }
      });
    });
  }

  private poiSave(data) {
    let self = this;

    if (self.currentCity && self.currentPoiLayer && self.currentPoiType) {
      // Exclude the POIs selected by the user
      const excludePoiIds = (self.currentMarkers || [])
        .map((currentMarker) =>
          currentMarker && currentMarker.poiID ? currentMarker.poiID : null,
        )
        .filter((poiId) => !!poiId);

      // Check if the post number is already in use, if so, do not save the POI
      if (
        data &&
        data.hasOwnProperty("post_number") &&
        data.post_number &&
        self.poiCheckDuplication(
          data.post_number.toString(),
          excludePoiIds,
          data.lighting_body,
        )
      ) {
        return;
      }

      if (
        data &&
        data.post_number &&
        Number.isInteger(parseInt(data.post_number))
      ) {
        if (self.numberingHistory.length == 2)
          self.numberingHistory[0] = self.numberingHistory[1];
        else self.numberingHistory[0] = parseInt(data.post_number);
        self.numberingHistory[1] = parseInt(data.post_number);
      }

      if (
        self.currentMarker &&
        self.currentMarker.position &&
        self.currentMarker.position.latitude &&
        self.currentMarker.position.longitude
      ) {
        if (self.interdistanceHistory.length == 2)
          self.interdistanceHistory[0] = self.interdistanceHistory[1];
        else
          self.interdistanceHistory[0] = {
            lat: self.currentMarker.position.latitude,
            lng: self.currentMarker.position.longitude,
          };
        self.interdistanceHistory[1] = {
          lat: self.currentMarker.position.latitude,
          lng: self.currentMarker.position.longitude,
        };
      }

      // Get the POI type from the id
      var poitype = self.getPoiTypeFromId(self.currentPoiType);
      var icon = "-";
      var addnew = data.addnew;

      // Build the preserved data for the add new poi
      const preservedDataForAddNew = addnew
        ? self.buildPreservedPoiDataForAddNew(data)
        : null;

      // Get the dirty fields (fields that have been changed)
      var dirtyFields = data.dirtyFields || {};
      delete data.dirtyFields;
      delete data.addnew;
      delete data.poiID;

      if (self.currentMarkers) {
        //Check if all poi has the same PoiType
        if (self.currentMarkers.length > 1) {
          const firstPoiType =
            self.poilayers[self.currentMarkers[0].layer].poi.items[
              self.currentMarkers[0].index
            ].type;
          const firstPoiTypeId =
            firstPoiType && (firstPoiType.id || firstPoiType.name);

          const allSameType = self.currentMarkers.every((m) => {
            const t = self.poilayers[m.layer].poi.items[m.index].type;
            if (!t || !firstPoiType) return !t && !firstPoiType;
            //If both have the id, compare by id
            if (firstPoiType.id && t.id) return firstPoiType.id === t.id;
            //Fallback and compare by name
            return firstPoiType.name === t.name;
          });

          // Check if all poi are in the same layer
          const firstLayer = self.poilayers[self.currentMarkers[0].layer];
          const firstLayerId = firstLayer && firstLayer.id;
          const allSameLayers = self.currentMarkers.every((m) => {
            const layer = self.poilayers[m.layer];
            return layer && layer.id === firstLayerId;
          });

          if (!allSameType) {
            self.snackbar.open(
              "Non è possibile modificare POI di tipo diverso",
              "ok",
              {
                duration: 2000,
                panelClass: ["white-snackbar"],
              },
            );
            self.resetCurrentMarker();
            self.poiFormPanel.close();
            return;
          }

          if (!allSameLayers) {
            self.snackbar.open(
              "Non è possibile modificare POI su layers diversi",
              "ok",
              {
                duration: 2000,
                panelClass: ["white-snackbar"],
              },
            );
            self.resetCurrentMarker();
            self.poiFormPanel.close();
            return;
          }
        }

        self.snackbar.open(
          "Updating " + self.currentMarkers.length + " poi...",
          "ok",
          { duration: 2000, panelClass: ["white-snackbar"] },
        );

        // Check if the poi is a single create
        const isSingleCreate =
          self.currentMarkers.length === 1 &&
          (!self.currentMarkers[0].poiID ||
            self.currentMarkers[0].poiID === "");

        if (isSingleCreate && self.currentPoiLayer) {
          self.movePoiMarkerToLayer(
            self.currentMarkers[0],
            self.currentPoiLayer,
          );
        }

        // Function to build the data for the poi
        const buildCandidateDataForMarker = (currentMarker, poiIndex) => {
          const isNewPoi = !currentMarker.poiID || currentMarker.poiID === "";
          const originalData = self.currentMarkers[poiIndex].data || {};
          let updatedData = { ...originalData };

          if (isNewPoi) {
            // If the poi is new, use the data from the form
            updatedData = { ...data };
          } else if (self.currentMarkers.length > 1) {
            // If the poi is not new and there are multiple poi, use the dirty fields
            Object.keys(dirtyFields).forEach((field) => {
              updatedData[field] = data[field];
            });
          } else {
            // If the poi is not new and there is only one poi, use the data from the form
            Object.keys(data).forEach((field) => {
              if (field === "addnew" || field === "poiID") return;
              if (
                dirtyFields[field] ||
                updatedData[field] === undefined ||
                updatedData[field] === null ||
                updatedData[field] === ""
              ) {
                updatedData[field] = data[field];
              }
            });
          }

          return updatedData;
        };

        // Multi-edit specific guard: detect duplicates created inside the selection itself
        if (self.currentMarkers.length > 1) {
          const seenKeys = {};
          const seenByPostNumber = {};
          let hasInternalDuplicates = false;

          self.currentMarkers.forEach((currentMarker, poiIndex) => {
            const candidateData = buildCandidateDataForMarker(
              currentMarker,
              poiIndex,
            );

            const candidatePostNumber = candidateData
              ? candidateData.post_number
              : null;
            if (
              candidatePostNumber === null ||
              candidatePostNumber === undefined ||
              candidatePostNumber === ""
            ) {
              return;
            }

            const postKey = candidatePostNumber.toString().trim().toLowerCase();
            const bodyValue =
              candidateData.lighting_body !== null &&
              candidateData.lighting_body !== undefined
                ? candidateData.lighting_body.toString().trim()
                : "";

            if (!seenByPostNumber[postKey]) {
              seenByPostNumber[postKey] = [];
            }

            const seenBodies = seenByPostNumber[postKey];

            // 1) Duplicate if the same lighting_body is already assigned to this post_number.
            if (seenBodies.indexOf(bodyValue) !== -1) {
              hasInternalDuplicates = true;
            }
            // 2) "Single" ("0") is exclusive on a post_number:
            //    - if current is Single, no other body can already exist on this post
            //    - if current is not Single, this post cannot already contain Single
            if (
              (bodyValue === "0" && seenBodies.length > 0) ||
              (bodyValue !== "0" && seenBodies.indexOf("0") !== -1)
            ) {
              hasInternalDuplicates = true;
            }

            seenBodies.push(bodyValue);

            const candidateKey = self.getDuplicateKey(
              candidatePostNumber,
              candidateData.lighting_body,
            );

            // Check if the current poi is duplicate by post number and lighting body
            if (seenKeys[candidateKey]) {
              hasInternalDuplicates = true;
            } else {
              seenKeys[candidateKey] = true;
            }
          });

          if (hasInternalDuplicates) {
            self.snackbar.open(
              "Non è possibile salvare: duplicati nella selezione (numero palo + corpo illuminante multiplo).",
              "ok",
              {
                duration: 4000,
                panelClass: ["white-snackbar"],
              },
            );
            return;
          }
        }

        const promises = self.currentMarkers.map((currentMarker, poiIndex) => {
          // Check if is update or create
          const isNewPoi = !currentMarker.poiID || currentMarker.poiID === "";

          // Get the source and target layer IDs
          const sourcePoiLayerId = self.poilayers[currentMarker.layer].id;

          // If only one POI is being saved, use the current POI layer. Otherwise, use its source layer (sourcePoiLayerId)
          const targetPoiLayerId =
            self.currentMarkers.length === 1 && self.currentPoiLayer
              ? self.currentPoiLayer
              : sourcePoiLayerId;

          let updatedData = buildCandidateDataForMarker(
            currentMarker,
            poiIndex,
          );

          // Filter the data to only include the fields that are in the form
          self.poilayers[currentMarker.layer].poi.items[
            currentMarker.index
          ].data = updatedData;

          if (poitype) {
            self.poilayers[currentMarker.layer].poi.items[
              currentMarker.index
            ].type = poitype;
          }

          if (!currentMarker.poiID || currentMarker.poiID === "") {
            if (!self.user) return Promise.resolve(null);

            // Create the poi
            return self.poiService
              .create(
                self.currentCity.id,
                targetPoiLayerId,
                self.currentPoiType,
                currentMarker.position.latitude,
                currentMarker.position.longitude,
                0,
                updatedData,
                self.user.username,
                self.user.organization,
                self.poiFiles,
                icon,
              )
              .then((createResult) => {
                if (
                  createResult &&
                  createResult.errors &&
                  createResult.errors.length > 0
                ) {
                  throw new Error(
                    createResult.errors[0].message || "Error creating poi",
                  );
                }

                if (
                  !createResult ||
                  !createResult.data ||
                  !createResult.data.createPoi ||
                  !createResult.data.createPoi.id
                ) {
                  throw new Error("Error creating poi, please retry");
                }

                const newId = createResult.data.createPoi.id;
                currentMarker.poiID = newId;

                if (isSingleCreate) {
                  self.lastInsertedPoi = newId;
                }

                const markerItem =
                  self.poilayers[currentMarker.layer] &&
                  self.poilayers[currentMarker.layer].poi &&
                  self.poilayers[currentMarker.layer].poi.items &&
                  self.poilayers[currentMarker.layer].poi.items[
                    currentMarker.index
                  ]
                    ? self.poilayers[currentMarker.layer].poi.items[
                        currentMarker.index
                      ]
                    : null;

                if (markerItem) {
                  markerItem.id = newId;
                  markerItem.data = updatedData;
                  markerItem.type = poitype;
                  markerItem.position_flr = 0;
                  markerItem.position_lat = currentMarker.position.latitude;
                  markerItem.position_lng = currentMarker.position.longitude;
                } else {
                  self.poilayers.forEach((poilayer) => {
                    if (poilayer.id == self.currentPoiLayer) {
                      if (!poilayer.poi) poilayer.poi = { items: [] };
                      if (!poilayer.poi.items) poilayer.poi.items = [];
                      const exists = poilayer.poi.items.some(
                        (p) => p && p.id === newId,
                      );
                      if (!exists) {
                        poilayer.poi.items.push({
                          id: newId,
                          data: updatedData,
                          type: {
                            id: poitype && poitype.id,
                            name: poitype && poitype.name,
                          },
                          position_flr: 0,
                          position_lat: currentMarker.position.latitude,
                          position_lng: currentMarker.position.longitude,
                        });
                      }
                    }
                  });
                }

                return createResult;
              });
          } else {
            if (!self.user) return Promise.resolve(null);
            var creator =
              ((currentMarker.data && currentMarker.data.owner) || "").split(
                "|",
              )[0] || self.user.username;
            var update_owner = creator + "|" + self.user.username;
            return self.poiService
              .update(
                currentMarker.poiID,
                self.currentCity.id,
                targetPoiLayerId,
                self.currentPoiType,
                currentMarker.position.latitude,
                currentMarker.position.longitude,
                0,
                updatedData,
                self.poiFiles,
                icon,
                update_owner,
              )
              .then((updateResult) => {
                if (
                  updateResult &&
                  updateResult.errors &&
                  updateResult.errors.length > 0
                ) {
                  throw new Error(
                    updateResult.errors[0].message || "Error updating poi",
                  );
                }

                if (
                  !updateResult ||
                  !updateResult.data ||
                  !updateResult.data.updatePoi ||
                  !updateResult.data.updatePoi.id
                ) {
                  throw new Error("Error updating poi, please retry");
                }

                if (
                  self.currentMarkers.length === 1 &&
                  targetPoiLayerId !== sourcePoiLayerId
                ) {
                  self.movePoiMarkerToLayer(currentMarker, targetPoiLayerId);
                }
                return updateResult;
              });
          }
        });

        // If all poi are saved correctly, reset the current marker and call the poiAdd function to add the new poi
        Promise.all(promises)
          .then(() => {
            self.resetCurrentMarker();
            self.snackbar.open("Poi saved correctly", "ok", {
              duration: 2000,
              panelClass: ["white-snackbar"],
            });
            if (addnew) {
              self.ngZone.run(() =>
                self.poiAdd("mapCenter", preservedDataForAddNew, true),
              );
            } else {
              self.poiFormPanel.close();
            }
          })
          .catch((err) => {
            self.logger.error(err);
            self.removeUnsavedPoiMarkers(self.currentMarkers);
            self.resetCurrentMarker();
            self.snackbar.open("Error saving poi, please retry", "ok", {
              duration: 5000,
              panelClass: ["white-snackbar"],
            });
          });
      } else {
        if (!self.currentCity) {
          self.snackbar.open("Select the city, before placing new poi", "ok", {
            duration: 2000,
            panelClass: ["white-snackbar"],
          });
        }
        if (!self.currentPoiLayer) {
          self.snackbar.open("Select the layer, before placing new poi", "ok", {
            duration: 2000,
            panelClass: ["white-snackbar"],
          });
        }
      }
    } else {
      console.warn(
        "[poiSave] Save skipped - missing required fields:",
        JSON.stringify({
          currentCity: self.currentCity ? self.currentCity.id : null,
          currentPoiLayer: self.currentPoiLayer || null,
          currentPoiType: self.currentPoiType || null,
        }),
      );
    }
  }

  private poiDelete(data) {
    let self = this;
    if (data)
      self.poiService
        .delete(data)
        .then((data) => {
          self.poilayers[self.currentMarker.layer].poi.items.splice(
            self.currentMarker.index,
            1,
          );
          self.resetCurrentMarker();
          self.poiFormPanel.close();
          self.snackbar.open("Poi deleted correctly", "ok", {
            duration: 2000,
            panelClass: ["white-snackbar"],
          });
        })
        .catch((err) => {
          self.logger.error(err);
        });
  }

  private deletePoiLayer(id) {
    let self = this;
    if (id) {
      self.layerService
        .delete(id)
        .then((data) => {})
        .catch((err) => {
          self.logger.error(err);
        });
    }
  }

  private addOrEditPoiLayer(id) {
    let self = this;
    let dialogRef;

    if (id) {
      self.poilayers.forEach((poilayer) => {
        if (poilayer.id == id) {
          dialogRef = self.dialog.open(PoiLayerDialogComponent, {
            width: "250px",
            data: {
              id: id,
              name: poilayer.name,
              color: "",
              layers: self.poilayers,
              kmlkmz: poilayer.kmlkmz,
            },
          });
        }
      });
    } else {
      dialogRef = self.dialog.open(PoiLayerDialogComponent, {
        width: "250px",
        data: {
          id: "",
          name: "",
          color: "",
          layers: self.poilayers,
          kmlkmz: "",
        },
      });
    }

    dialogRef.afterClosed().subscribe((result) => {
      if (result && self.currentCity && self.currentCity.id) {
        if (self.user) {
          if (result.id) {
            self.layerService
              .update(result.id, result.name, "#FF0000", result.kmlkmz, null)
              .then((data) => {
                for (let poilayer of self.poilayers) {
                  if (poilayer.id === result.id) {
                    poilayer.name = result.name;
                    poilayer.color = result.color;
                    poilayer.kmlkmz = result.kmlkmz;
                    return;
                  }
                }
              })
              .catch((err) => {
                self.logger.error(err);
              });
          } else {
            self.layerService
              .create(
                result.name,
                "#FF0000",
                result.kmlkmz,
                null,
                self.currentCity.id,
                self.user.username,
                self.user.organization,
              )
              .then((data) => {
                self.poilayers.push({
                  id: data.data.createPoiLayer.id,
                  name: result.name,
                  color: "",
                  data: "",
                  kmlkmz: "",
                  poi: { items: [] },
                });
              })
              .catch((err) => {
                self.logger.error(err);
              });
          }
        }
      }
    });
  }

  private initializeUserPosition() {
    let self = this;
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        function (position) {
          self.ngZone.run(() => {
            self.currentUserPosition = {
              latitude: position.coords.latitude,
              longitude: position.coords.longitude,
              zoom: 15,
            };
            self.mapCenter.latitude = position.coords.latitude;
            self.mapCenter.longitude = position.coords.longitude;
            self.mapCenter.zoom = 15;
          });
        },
        function (error) {
          console.log("Geolocation error", error.code);
        },
      );
    }
  }
}

@Component({
  selector: "app-poilayer-dialog-component",
  templateUrl: "./layer.dialog.html",
})
export class PoiLayerDialogComponent implements OnInit {
  id: string;
  name: string;
  color: string;
  layers: any[];
  kmlkmz: string;
  error: string;

  constructor(
    public dialogRef: MatDialogRef<PoiLayerDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: PoiLayer,
  ) {
    this.id = data.id;
    this.name = data.name;
    this.color = data.color;
    this.kmlkmz = data.kmlkmz;
    this.layers = data["layers"];
  }

  ngOnInit() {}

  onNoClick(): void {
    this.dialogRef.close();
  }

  upload(data) {
    let self = this;
    Storage.put("kmlkmz/" + data.target.files[0].name, data.target.files[0], {
      contentType: data.target.files[0].type,
      level: "public",
      ACL: "public-read",
    })
      .then((result) => {
        if (result && result["key"]) {
          self.kmlkmz =
            "https://qstorage160746-prod.s3.eu-west-1.amazonaws.com/public/" +
            result["key"];
        }
      })
      .catch((err) => console.log(err));
  }

  save() {
    let self = this;
    /* for (let poilayer of self.layers) {
      if (poilayer["name"].toString().toUpperCase() === self.name.toUpperCase()) {
        self.error = "Duplicate of layer is not allowed";
        return;
      }
    } */
    self.dialogRef.close({
      id: self.id,
      name: self.name,
      color: self.color,
      kmlkmz: self.kmlkmz,
    });
  }

  close() {
    this.dialogRef.close();
  }

  removeKmlKmz() {
    let self = this;

    if (!self.kmlkmz) return;

    self.kmlkmz = "";
  }
}

@Component({
  selector: "app-poilayer-dialog-component",
  template:
    '<h1 mat-dialog-title>Attenzione, il numero di POI già in uso! Cambiare numero</h1><div mat-dialog-content><div mat-dialog-actions><button mat-button (click)="onNoClick()">OK</button></div>',
})
export class DialogPOIExists {
  constructor(public dialogRef: MatDialogRef<DialogPOIExists>) {}

  onNoClick(): void {
    this.dialogRef.close();
  }
}

@Component({
  selector: "stats-dialog",
  templateUrl: "./stats.dialog.html",
})
export class StatsDialog {
  private stats = [];

  constructor(
    public dialogRef: MatDialogRef<StatsDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any[],
  ) {
    this.stats = data["stats"];
    console.log(this.stats);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
